import { Component, OnInit, Input, Output, EventEmitter, OnChanges, Inject } from '@angular/core';
import { Location } from '@angular/common';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { debounceTime, first } from 'rxjs/operators';
import { interval, Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { NoteService } from '@app/_components/task/note';
import { AlertService, AuthenticationService } from '@app/_services';
import { ApiResponse, User } from '@app/_models';
import { Note } from '@app/_components/task/note';
import { SelectItem, LazyLoadEvent } from 'primeng/api';
import { take } from 'rxjs/operators';




@Component({
    selector: 'app-note',
    templateUrl: './note.component.html',
    styleUrls: ['./note.component.css'],
    standalone: false
})
export class NoteComponent implements OnInit, OnChanges {
	updatedescriptioninterval: any;
	currentUser: User;
	currentUserSubscription: Subscription;
	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private noteService: NoteService,
		private alertService: AlertService,
		private location: Location,
		private authenticationService: AuthenticationService,
		private dialog: MatDialog,
		private formBuilder: UntypedFormBuilder,
		private route: ActivatedRoute,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.note = data.note,
			this.noteSource = data.noteSource,
			this.noteSourceId = data.noteSourceId;
		try {
			if (this.route?.snapshot?.params['requestData']) {
				// when we need to retrieve data trough URL we are base64 encoding and decoding to get the data back
				let requestData = this.route.snapshot.params['requestData'];
				requestData = atob(requestData);
				let dataReceived = requestData.split('!~~!');
				this.noteSource = dataReceived[0];
				this.noteSourceId = dataReceived[1];
				this.updateRequestedByUserId = dataReceived[2];
			}
		} catch (e) { }
		this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
			this.currentUser = user;
		});
	}

	// inputs
	@Input() noteSource: number;
	@Input() noteSourceId: number;
	@Input() updateRequestedByUserId: number;

	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doAddDontClose = new EventEmitter<any>();
	@Output() doUpdateDontClose = new EventEmitter<any>();
	formTitle: String;

	noteId: any;

	// structure
	subscription: Subscription;
	routerLocation = this.location;


	// data
	noteApiResponse: ApiResponse;


	// list
	datasource: Note[];

	notes: Note[] = [];
	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;

	multiSortMeta = [];


	// forms
	noteAddForm: UntypedFormGroup;
	formLoading = false;
	formAction: String;
	formLabels = [];
	formReadOnly = false;
	note: any;
	noteTypes = [
		{ value: 1, name: 'General', color: '#DCDCDC' },
		{ value: 2, name: 'Action Item', color: '#ffcccc' },
		{ value: 4, name: 'Meeting Notes', color: '#ade061' },
		{ value: 5, name: 'Status Update', color: '#FFFF99' },
	];

	visibilities = [
		{ value: 1, name: 'Company' },
		{ value: 2, name: 'Team' },
		{ value: 3, name: 'Personal' },
		{ value: 4, name: 'Customer/Owner' }
	];

	statuses = [
		{ value: null, name: '' },
		{ value: 0, name: 'Open' },
		{ value: 1, name: 'Complete' },
		{ value: 2, name: 'Proposed' },
		{ value: 3, name: 'On Hold' },
		{ value: 4, name: 'Canceled' },
		{ value: 5, name: 'In Progress' }
	];

	columns: any[] = [
		{ field: 'title', header: 'Title', width: '25%' },
		{ field: 'description', header: 'Description', width: '25%' },
		{ field: 'status', header: 'Status', width: '10%' },
		{ field: 'createDate', header: 'Created', width: '10%' },
		{ field: 'lastUpdate', header: 'Edited', width: '10%' },
		{ field: 'noteType', header: 'Type', width: '10%' },
		{ field: 'visibility', header: 'Visibility', width: '10%' },
	];

	filters: any[] = [

		{ label: 'Created', value: 'createDate' },
		{ label: 'Edited', value: 'lastUpdate' },
		{ label: 'Status', value: 'status' },
		{ label: 'Type', value: 'noteType' },
		{ label: 'Visibility', value: 'visibility' },

	];


	// Guard flag — true while a POST/PATCH for this note is in flight.
	// Prevents the 10-second autosave interval from issuing duplicate POSTs
	// when the server is slow or returning 504 (the duplicate-note bug, 2026-05-20).
	private pendingSave = false;

	// validation
	validationMessages = {
		'name': [
			{ type: 'required', message: 'Required' }
		],
		'noteId': [],
		'createDate': [],
		'lastUpdate': [],
		'title': [],
		'description': [{ type: 'required', message: 'Required' }],
		'status': [{ type: 'required', message: 'Required' }],
		'noteType': [],
		'visibility': []
	};


	ngOnInit() {
		this.buildAddForm();

		try {
			// adding
			if (this.noteSourceId == null) {
				console.log('action: add.  ns' + this.noteSource + ' ' + this.noteSourceId);
			}

			// editing
			if (this.noteSourceId != null) {
				console.log('action: edit');
			}


			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });

			// if we were passed the whole proformaIncome object
			if (this.note) {
				this.noteId = this.note.noteId;
				this.noteAddForm.patchValue(this.note);
			}
			// if (!this.updateRequestedByUserId) {
			// 	this.noteAddForm.valueChanges.pipe(debounceTime(2000)).subscribe(formData => {
			// 		if (this.noteAddForm && this.noteAddForm.dirty) {
			// 			if (this.note?.noteId) {
			// 				this.notesUpdate();
			// 			}
			// 			else {
			// 				this.formAddAndDontClose();
			// 			}
			// 		}
			// 	});
			// }
			// else {
			// 	this.noteAddForm.patchValue({ title: 'status update' });
			// }
			this.noteAddForm.patchValue({ noteType: 5 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}



	formAdd() {
		// Guard: prevent duplicate POSTs when the server is slow or returns 504
		if (this.pendingSave) { return; }
		console.log('trying to add: ');
		try {
			// stop here if form is invalid
			if (this.noteAddForm.invalid) {
				return;
			}
			let createdBy = new User();
			createdBy.userId = this.currentUser.userId;
			this.formLoading = true;
			if (this.noteAddForm.value.description) {
				// this.noteAddForm.value.description = this.noteAddForm.value.description.replace(/\n/g, '<br>');
			}
			this.noteAddForm.value.createdBy = createdBy;
			this.pendingSave = true;
			if (this.updateRequestedByUserId) {
				this.noteService.addFromForm(this.noteAddForm.value, this.updateRequestedByUserId).pipe(take(1))
					.subscribe(
						res => {
							console.log('Note-Add SUCCESS: ' + JSON.stringify(res));
							this.alertService.success(res, true);
							this.notes.unshift(res.data.note);
							this.buildAddForm();
							window.close();
						},
						err => {
							console.log('Note-Add FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { this.pendingSave = false; this.formLoading = false; });
			}
			else {
				// use the .pipe(take(1)) to prevent double firing...
				this.noteService.add(this.noteAddForm.value).pipe(take(1))
					.subscribe(
						res => {
							console.log('Note-Add SUCCESS: ' + JSON.stringify(res));
							this.alertService.success(res, true);
							this.notes.unshift(res.data.note);
							this.buildAddForm();
							this.doAdd.emit(res.data.note);
						},
						err => {
							console.log('Note-Add FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { this.pendingSave = false; this.formLoading = false; });
			}

		} catch (error) {
			this.alertService.error(error);
		}
	}
	formAddAndDontClose() {
		// Guard: prevent duplicate POSTs when the server is slow or returns 504
		if (this.pendingSave) { return; }
		console.log('trying to add: ');
		try {
			// stop here if form is invalid
			if (this.noteAddForm.invalid) {
				return;
			}

			this.pendingSave = true;
			this.formLoading = true;

			if (this.updateRequestedByUserId) {
				this.noteService.addFromForm(this.noteAddForm.value, this.updateRequestedByUserId).pipe(take(1))
					.subscribe(
						res => {
							console.log('Note-Add SUCCESS: ' + JSON.stringify(res));
							this.alertService.success(res, true);
							this.notes.unshift(res.data.note);
							this.buildAddForm();
							this.doAdd.emit(res.data.note);
						},
						err => {
							console.log('Note-Add FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { this.pendingSave = false; this.formLoading = false; });
			}
			else {
				this.noteService.add(this.noteAddForm.value).pipe(take(1))
					.subscribe(
						res => {
							console.log('Note-Add SUCCESS: ' + JSON.stringify(res));
							this.alertService.success(res, true);
							this.notes.unshift(res.data.note);
							this.note = res.data.note;
							this.noteId = this.note.noteId;
							let custNote = this.note;
							delete custNote?.description;
							this.noteAddForm.patchValue(custNote);
							this.doAddDontClose.emit(res.data.note);
						},
						err => {
							console.log('Note-Add FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { this.pendingSave = false; this.formLoading = false; });
			}
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		// Guard: prevent duplicate PATCHes when the server is slow or returns 504
		if (this.pendingSave) { return; }
		try {
			// stop here if form is invalid
			console.log('Form Submitted: ' + JSON.stringify(this.noteAddForm.value));
			if (this.noteAddForm.invalid) {
				console.log('Form Invalid: ' + JSON.stringify(this.noteAddForm.getError));
				return;
			}

			this.pendingSave = true;
			this.formLoading = true;
			// this.noteAddForm.value.description = this.noteAddForm.value.description.replace(/\n/g, '<br>');
			this.noteService.update(this.noteAddForm.value)
				.subscribe(
					res => {
						console.log('Note-Update SUCCESS: ' + JSON.stringify(res));

						// update the list
						this.notes.forEach((note, i) => {
							if (note.noteId === res.data.note.noteId) {
								this.notes[i] = res.data.note;
							}
						});
						this.alertService.success(res, true);
						this.doUpdate.emit(res.data.note);
					},
					err => {
						console.log('Note-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.pendingSave = false; this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}
	loadLazy(event: LazyLoadEvent) {

		this.lazyLoadEvent = event;
		const pageNumber = Math.round(event.first / event.rows);
		console.log(
			' event.first:' + event.first
			+ '  |  event.rows:' + event.rows
			+ '  |  event.sortField:' + event.sortField
			+ '  |  event.sortOrder:' + event.sortOrder
			+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
			+ '  |  event.globalFilter:' + event.globalFilter
			+ '  |  event.filters:' + JSON.stringify(event.filters)
		);

		// if empty (ie when parent is in 'add' and we dont' have a sourceId yet), do nothing
		if (this.noteSource == null || this.noteSourceId == null) {
			setTimeout(() => {
				// we have to wait a second as the table is still loading to prevent a ExpressionChangedAfterItHasBeenCheckedError
				this.loading = false;
			}, 1);
			return;
		}

		this.noteService.findBySource(
			pageNumber, event.rows,
			event.sortField,
			event.sortOrder,
			event.multiSortMeta,
			event.globalFilter,
			event.filters,
			this.noteSource,
			this.noteSourceId).pipe(first()).subscribe(

				apiResponse => {
					console.log('notes are: ' + JSON.stringify(apiResponse));
					this.datasource = apiResponse.data.notes;
					this.notes = apiResponse.data.notes;
					this.recordTotal = apiResponse.page.recordTotal;
				},
				apiResponse => {
					console.log('USER LIST!: ' + JSON.stringify(apiResponse));
					this.alertService.error(apiResponse);
				},
				() => { this.loading = false; }
			);

		try {
			if (this.datasource) {
				this.notes = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}



	sortList(event) {
		console.log('formTest', event);
		this.multiSortMeta = [];
		this.multiSortMeta.push({ field: event.value.value, order: 0 });
		this.lazyLoadEvent.multiSortMeta = this.multiSortMeta;
		this.loadLazy(this.lazyLoadEvent);
	}

	updateToNoteList(event) {
		console.log('updateNoteList', event);
		this.notes.forEach((note, i) => {
			if (note.noteId === event.noteId) {
				this.notes[i] = event;
			}
		});
	}


	ngOnChanges() {
		// This is called when the parent updates. When the parent first initializes, it is in add state, and we have no taskId.  This sets the taskId when add is successful.
		if (this.noteAddForm !== undefined) {
			this.noteAddForm.patchValue({ noteSourceId: this.noteSourceId });
		}
	}

	buildAddForm() {
		this.noteAddForm = this.formBuilder.group({
			noteId: [],
			noteSourceId: [this.noteSourceId],
			noteSource: [this.noteSource],
			createDate: [],
			lastUpdate: [],
			title: [],
			description: [],
			status: [0, Validators.required],
			noteType: [1, Validators.required],
			visibility: [1, Validators.required]
		});
	}

	reloadPage() {
		window.location.reload();
	}

	displayPaginator() {
		if (this.notes && this.notes.length > 25) {
			return true;
		}
		else {
			return false;
		}
	}

	onDescriptionBlur() {
		this.updatedescriptioninterval.unsubscribe();
	}

	onDesciptionFocus() {
		this.updatedescriptioninterval = interval(10000).subscribe(x => {
			this.updateFormFOrDescription();
		});
	}

	private updateFormFOrDescription() {
		console.log('inside update ');
		// Do not fire a second save while one is already in flight — this prevents
		// duplicate note rows when the server is slow or returning 504 (2026-05-20 fix).
		if (this.pendingSave) {
			console.log('Note autosave skipped — previous save still in flight');
			return;
		}
		if (!this.note) {
			this.pendingSave = true;
			this.noteService.add(this.noteAddForm.value).pipe(take(1))
				.subscribe(
					res => {
						console.log('Note-Add SUCCESS: ' + JSON.stringify(res));
						this.alertService.success(res, true);
						this.notes.unshift(res.data.note);
						this.note = res.data.note;
						this.noteId = this.note.noteId;
						let custNote = this.note;
						delete custNote?.description;
						this.noteAddForm.patchValue(custNote);
						this.doAddDontClose.emit(res.data.note);
					},
					err => {
						console.log('Note-Add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.pendingSave = false; this.formLoading = false; });
		}
		else {
			if (this.note.description !== this.noteAddForm.value.description) {
				this.notesUpdate();
			}
		}
	}
	notesUpdate() {
		if (!this.note) {
			return;
		}
		// Guard against duplicate PATCH calls from the autosave interval (2026-05-20 fix).
		if (this.pendingSave) {
			console.log('Note autosave update skipped — previous save still in flight');
			return;
		}
		this.pendingSave = true;
		this.noteService.update(this.noteAddForm.value)
			.subscribe(
				res => {
					console.log('Note-Update SUCCESS: ' + JSON.stringify(res));

					// update the list
					this.notes.forEach((note, i) => {
						if (note.noteId === res.data.note.noteId) {
							this.notes[i] = res.data.note;
						}
					});
					this.note = res.data.note;
					this.alertService.success('notes updated...', true);
					this.doUpdateDontClose.emit(res.data.note);
				},
				err => {
					console.log('Note-Update FAIL: ' + JSON.stringify(err));
					this.alertService.error(err);
				},
				() => {
					this.pendingSave = false;
					this.formLoading = false;
				});
	}
}
